import {Component, ElementRef} from '@angular/core';
import * as $ from 'jquery';
import MenuTogglerService from "../../services/menuToggler.service";
import {ActivatedRoute} from '@angular/router';
import MeasurementsDataProvider from "../../services/dataProviders/measurementsDataProvider.service";
import IMeasurement from "../../interfaces/IMeasurement";
import IMapOptions from "../../interfaces/IMapOptions";

@Component({
    selector: 'map-details',
    template: require('./mapDetails.component.html'),
    styles: [String(require('./mapDetails.styl'))],
})

export class MapDetailsComponent {
    private toggle;
    private measurement: IMeasurement;
    private state: string = 'idle';
    public mapOptions: IMapOptions = {
        type: 'active',
        showDetails: false
    }

    constructor(private toggler: MenuTogglerService,
                private measurementsDataProvider: MeasurementsDataProvider,
                private element: ElementRef,
                private activatedRoute: ActivatedRoute) {
        this.toggle = () => {
            this.toggler.toggleLeftMenu();
        }
    }

    ngAfterViewInit() {
        this.activatedRoute.params.subscribe((params: any) => {
            this.measurementsDataProvider.getOne(params.id).subscribe((measurement: IMeasurement) => {
                this.measurement = measurement;
                this.state = 'has_data';
            }, () => {
                this.state = 'no_data';
            })
        })
    }

    ngOnInit() {
        this.toggler.mainContentContainer = $(this.element.nativeElement).find('.mainContentContainer');
    }

}



// WEBPACK FOOTER //
// ./src/app/components/mapDetails/mapDetails.component.ts